import React from "react";
import { Button, ButtonVariants } from "../core/Button/Button";
import { ReactComponent as CheckIcon } from "../../icons/check.svg";
import { ReactComponent as CancelIcon } from "../../icons/close.svg";
import { CANCEL_LABEL, CONFIRM_LABEL } from "../../constants/Dictionary";
import { BodyTyp } from "../Typography/Typography";
import { FontWeightEnum } from "../../types/AppTypes";
import { Modal } from "../core/Modal/Modal";
import { Loader } from "../core/Loader/Loader";
import {
  StyledLoadingMessageContainer,
  StyledPopupConfirm,
} from "./PopupConfirm.styled";

type PopupConfirmProps = {
  isOpen: boolean;
  label: string;
  onConfirm: () => void;
  onCancel: () => void;
  popupText: string;
  isLoading?: boolean;
  loadingMessage?: React.ReactNode;
};

export const PopupConfirm = ({
  isOpen,
  label,
  onConfirm,
  onCancel,
  popupText,
  isLoading,
  loadingMessage,
}: PopupConfirmProps) => {
  if (!isOpen) {
    return null;
  }

  const isLoadingWithMessage = isLoading && loadingMessage;

  return (
    <Modal
      label={label}
      fullSize={false}
      isOpen={isOpen}
      rightButton={
        isLoadingWithMessage ? undefined : (
          <Button
            icon={<CheckIcon />}
            label={CONFIRM_LABEL}
            onClick={onConfirm}
            disabled={isLoading}
          />
        )
      }
      leftButton={
        isLoadingWithMessage ? undefined : (
          <Button
            variant={ButtonVariants.SECONDARY}
            icon={<CancelIcon />}
            label={CANCEL_LABEL}
            onClick={onCancel}
            disabled={isLoading}
          />
        )
      }
    >
      <StyledPopupConfirm>
        {isLoadingWithMessage ? (
          <StyledLoadingMessageContainer>
            <Loader size={30} loading={isLoading ?? false} />
            {loadingMessage}
          </StyledLoadingMessageContainer>
        ) : (
          <Loader size={30} loading={isLoading ?? false}>
            <BodyTyp variant="1" fontWeight={FontWeightEnum.REGULAR}>
              {popupText}
            </BodyTyp>
          </Loader>
        )}
      </StyledPopupConfirm>
    </Modal>
  );
};
